import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

import { LevelEnum } from '~/core/enums/level.enum';

/*
 * Display the level of an activity
 * Usage:
 *   level | displayLevel
 * Example:
 *   {{ [5, 10] | displayLevel }}
 *   formats to: beginner, confirmed
 */
@Pipe({ name: 'displayLevel' })
export class DisplayLevelPipe implements PipeTransform {
  constructor(private readonly translateService: TranslateService) {}

  public transform(values: number[]): string {
    if (!values?.length) {
      return;
    }

    return values
      .map((level) => {
        if (level === LevelEnum.BEGINNER) {
          return this.translateService.instant('level.beginner');
        }

        if (level === LevelEnum.CONFIRMED) {
          return this.translateService.instant('level.confirmed');
        }

        if (level === LevelEnum.EXPERT) {
          return this.translateService.instant('level.expert');
        }

        return '';
      })
      .filter((translatedLevel) => translatedLevel)
      .join(', ');
  }
}
